var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"13","height":"11","viewBox":"0 0 13 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.56958 5.5001L4.74477 8.79961L12.1134 1.14246","stroke":"currentColor","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }